define('responsive-gameday/controllers/VideosViewController',['require','exports','module','GameDayCore','Responsive/controllers/ScrollViewController','../views/render/VideosViewRender','Responsive/util/imageDensity','Responsive/vendor','image-loader/image-loader','Responsive/util/renderComplete','../views/Monitor/Events/ViewModelUpdateEvents','message-service/message-service','gameday-index-url-hasher/UrlHasher','extant/extant','Wax/Wax','responsive-pitch-fx/lib/helpers/domHelper','responsive-gameday-tracking/responsive-gameday-tracking','GameDayCore/GDModel/enums/datasources/Datasources'],function(require,exports,module) {

	// Add private variables here
    var GDC = require("GameDayCore"),
        ScrollViewController = require("Responsive/controllers/ScrollViewController"),
        VideosViewRender = require( '../views/render/VideosViewRender' ),

        ImageDensity = require("Responsive/util/imageDensity"),
        Vendor = require("Responsive/vendor"),
        imageLoader = require("image-loader/image-loader"),
        renderComplete = require("Responsive/util/renderComplete"),
        VMEvents = require("../views/Monitor/Events/ViewModelUpdateEvents"),
        MessageService = require("message-service/message-service"),
        UrlHasher = require("gameday-index-url-hasher/UrlHasher"),
        exists = require("extant/extant"),
        Wax = require( 'Wax/Wax'),
        DomHelper = require('responsive-pitch-fx/lib/helpers/domHelper'),
        Tracking = require("responsive-gameday-tracking/responsive-gameday-tracking"),
        Datasources = require("GameDayCore/GDModel/enums/datasources/Datasources");

	var VID_FRAME = "/gameday/wrapper/v2/RC1/subcomponents/videoframe.html?width=300&height=169&property=mlb&cacheBust=1400786315115&autoplay={AUTOPLAY}&content_id={CID}",
		AUTOPLAY = "{AUTOPLAY}",
		CONTENTID = "{CID}"

	var Superclass,
        doc = document,
        videocore = true,
		selector = function (prop) {
			return function () {
				var urls = this[prop];
				return ImageDensity.choose(doc.body, urls.low, urls.high);
			};
		};

    // Constructor
    function VideosViewController() {
        // Call super constructor
        Superclass.constructor.call(this);
        this.viewRender = new VideosViewRender();
        // 'private' attributes
        var videoPlayer,
            self = this;

        MessageService.one(GDC.requestGameData(Datasources.STATIC_RESOURCES), function() {
			var statics = GDC.getGameData(Datasources.STATIC_RESOURCES)[Datasources.STATIC_RESOURCES];
			videocore = (exists(statics) && (statics.videoFormat === "videocore"));
		});

        // public attributes
        this.times = {};
        this.replayVideos = [],
        this.mainVideo = null;
        this.playList = null;

        this.commercialBreakInProgress = false;
        this.queuedVideo = null;
        this.referenceName = "videos";
        this.selectedVid = null;

        this.playVideo = function(payload, evt) {
            if (videocore) {
                if (UrlHasher.getHashParams().game_tab === self.referenceName) {
                    createWiredPlayer(payload.contentID, true);
                } else {
                    self.queuedVideo = payload.contentID;
                    UrlHasher.setHashParams({ game_tab: "videos" });
                }
            }
        };

        this.setVideo = function(payload, evt) {
            if (videocore && !exists(videoPlayer)) {
                createWiredPlayer(payload.contentID,false);
            }
        };

        this.stopVideo = function() {
            if (exists(videoPlayer)) {
                videoPlayer.stop();
            }
        };

        this.destroyWiredPlayer = function() {

            // destroy video container when disappearing
            DomHelper.remove(this.getView().querySelector('#gdVideoContainer'));
            videoPlayer = null;
        }

        function launchPlayer(player, wrapper) {
            player[player.paused ? 'play' : 'pause']();
            wrapper.setAttribute('data-loading');
        }

        function createWiredPlayer(contentID,autoplay) {
            // Set iScroll panel to relative so video player can come in
            // and push playlist iscroll down
            var ensurePlayer = renderComplete;
            
           
            if (!exists(doc.getElementById("gdVideoContainer"))) {
                addVideoTplToView(contentID,autoplay);
            }

            renderComplete(function(){
                videoPlayer = doc.getElementById("gdVideoWrapper");

                if (exists(videoPlayer)) {
                    videoPlayer.src=videoPlayer.src.replace(/(?:#.*|$)/,'#play='+contentID+',autoplay='+autoplay);
                    // videoPlayer.play((contentID||"").toString(), undefined, autoplay);

                    var videoData = GDC.getGameData("video").video;
                        theVO = (exists(videoData)) ? videoData.videosByCID["cid_" + contentID] : { blurb: "", review: false },
                        msg = theVO.blurb;
                    if (theVO.review) {
                        msg = '<div id="selectedTitleFlag" class="videoLabelFlag reviewLabel"><h3 id="selectTitleFlagDescrip">REPLAY</h3></div>' + theVO.blurb;
                    } else if (theVO.statscast) {
                        msg = '<div id="selectedTitleFlag" class="statscastLabel"><h3 id="selectTitleFlagDescrip"></h3></div>' + theVO.blurb;
                    }

                    doc.getElementById("selectedTitle").innerHTML = msg;
                    self.selectedVid="video-"+contentID;
                    self.selectVideo();
                }
                // renderComplete(function(){
                //     if()
                // })
            });
        }

        function addVideoTplToView(cid,autoplay) {
            var vidDiv = doc.createElement('div'),
                videoData = GDC.getGameData("video").video,
                vidVO = (exists(videoData)) ? videoData.videosByCID["cid_" + cid] : { blurb: "", review: false };

            vidDiv.id = "gdVideoContainer";
            vidDiv.className = "wiredGDVideoWrapper";

			self.getView().insertBefore(vidDiv, self.getView().firstChild);

            if(vidVO){
                vidVO.src = VID_FRAME.replace(AUTOPLAY, autoplay).replace(CONTENTID, cid);
            }
            
            vidDiv.innerHTML = self.viewRender.renderPartial('videocorePlayerView',vidVO);

            // MessageService.publish(VMEvents.REQUEST_VIDEO_DATA);

            $(vidDiv).on("click dblclick touchstart touchmove mousemove", 'object', function(e) {
                e.cancelBubble = true;
                e.preventDefault();
                e.stopPropagation(); return true;
            });
        }

        MessageService.publish("registerViewComponent", this);
    }

	// Add private methods here

	function createNativePlayer(player) {
        var that = this,
            wrapper;

        if (!exists(player)) {
            wrapper = doc.createElement('div');
            wrapper.className = "offScreenVideoContainer";

            player = doc.createElement('video');
            player.controls = "controls";
         } else {
            wrapper.style.display = "none";
         }
        player.preload = "metadata";
        player.setAttribute('autobuffer', "autobuffer");

        player.className = "offScreenVideoPlayer";

        player.addEventListener("canplay", function () {
            if (player.paused) {
                clearTimeout(player.timed);
                launchPlayer.call(that, player, wrapper);
            }
        }, false, false);

        player.addEventListener("playing", function () {
            var h, w;
            wrapper.setAttribute('data-loading', false);
            h = wrapper.offsetHeight;
            w = wrapper.offsetWidth;

            that.checkHeight();
            return true;
        }, true, false);

        player.addEventListener('click', function (e) {
        if (e.fake && e.src !== player.src) {
            player.pause();
            wrapper.setAttribute('data-loading', true);
            player.setAttribute('poster', e.poster);
            player.setAttribute('data-src', e.src);
            player.setAttribute('src', e.src);
            player.setAttribute('data-id', e.id);

            if (false && player.webkitRequestFullScreen) {
                player.webkitRequestFullScreen();
            } else {

            }

            player.load();
            player.timed = setTimeout(function () {
                launchPlayer.call(that, player, wrapper);
            }, 250);

            return false;

        } else {
            if (exists(player.controls) || e.fake) {
                // alert(e.src);
                player.setAttribute('data-src', e.src);
                player.setAttribute('data-id', e.id);
                launchPlayer.call(that, player, wrapper);
             }
            return false;
        }

        }, true, false);

        // view.innerHTML=playerstr+' controls autoplay preload="auto" crossOrigin="anonymous" mediagroup="vid"></video>';
        wrapper.appendChild(player);
        this.getView().insertBefore(wrapper, this.childWrapper);
        this.playerContainer = wrapper;

        return player;
	}

	// Prototype Inheritence
	ScrollViewController.spawn(VideosViewController).define({
        loadView: function () {
            Superclass.loadView.call(this);
            this.content = null;
        },

		draw: function () {
			Superclass.draw.call(this);
			this.setClassName("VideosViewController");
        },

		viewWillAppear: function () {
			var that = this,
				playerContainer = that.playerContainer;

            if (this.onBeat) {
                MessageService.removeListener.call(this, VMEvents.UPDATE_VIDEO, this.onBeat);
            }

			this.onBeat = function (payload, evt) {

				that.childWrapper.innerHTML = that.viewRender.render(payload);
                that.childWrapper.querySelector('#playlist').innerHTML =that.viewRender.renderPartial('playlistView',payload);

				renderComplete(function () {
					// that.generateThumbs(videoData);
					that.setHandlers();
					that.hideOverlay();
                    that.selectVideo();
                    that.setScroll(that.getView().querySelector('#playlist'));
                    // if videoPlayer exists, set the following css on iscroll
                    if (exists(that.videoPlayer)) {
                    var iscrollContainer = that.getView().querySelector('.is-iscroll');      
                        if (exists(iscrollContainer) && exists(iscrollContainer.style)) {
                            iscrollContainer.style.position = "relative";
                            iscrollContainer.style.overflow = "hidden";            
                        }
                    }
                });
			};

            Tracking.track_video_tab_launch();
			Superclass.viewWillAppear.call(this);
			this.showOverlay();

            // set listener for video events, call first run...
            MessageService.addListener.call(this, VMEvents.UPDATE_VIDEO, this.onBeat);
		},

        selectVideo : function(){
            if (!exists(this.selectedVid)) {
                var plist = $('#playlist li');
                if (plist.length > 0) {
                    this.selectedVid = plist[0].getAttribute("id");
                } else {
                    return;
                }
            }

            var selectedDiv = doc.getElementById(this.selectedVid);
            $('#playlist .selected',this.getView()).removeClass('selected');
            if (exists(selectedDiv)) { 
                selectedDiv.className = "selected"; 
                if (!exists(this.queuedVideo)) {
                    var cid = selectedDiv.getAttribute("data-id");
                    this.setVideo({ contentID: cid });
                }
            }
        },

        viewDidAppear: function() {
            Superclass.viewDidAppear.call(this);
            MessageService.publish(VMEvents.REQUEST_VIDEO_DATA);

            // if there's a queued video, play it!
            if (exists(this.queuedVideo)) {
                this.playVideo({ contentID: this.queuedVideo });
                this.queuedVideo=null;
            }
        },

		viewWillDisappear: function() {
			var that = this;
			videoPlayer = null;
			that.videoContainer = null;
            that.destroyWiredPlayer();
			if (this.onBeat) {
				MessageService.removeListener(VMEvents.UPDATE_VIDEO, this.onBeat);
			}

            Superclass.viewWillDisappear.call(this);
		},

		setHandlers: function() {
			var view = this.getView(),
				that = this,
				moving = false;
            $(view).on('click mousedown mouseup mousemove', 'object,video',function(e){
                e.stopImmediatePropagation();
                return true;
            });

			$('#playlist').off('scroll touchmove mousemove').on('scroll touchmove mousemove', function () {
				moving = true;
			});

            $('#playlist li').on(Vendor.eventMap.START, function () {
                moving = false;
            }).on('click',function () {
                moving = false;
            }).on(Vendor.eventMap.END, function (e) {
                if (moving || (e.target && e.target.className.indexOf('sharable') !== -1)) {
                    return true;
                }

                var vid;

                if (!exists(that.selectedVid) || that.selectedVid !== this.id) {
                    this.className = "selected";
                    var lastElem = doc.getElementById(that.selectedVid);
                    if (exists(lastElem)) lastElem.className = "";

                    that.selectedVid = this.id;
                }
                Tracking.track_video_list_click();
                if (videocore) {
                    that.playVideo({ contentID: this.getAttribute('data-id') });
                } else {
                    var evt = document.createEvent('MouseEvents');
                    vid = createNativePlayer.call(that, videoPlayer);
                    evt.initMouseEvent('click', true, false, window, 1, 0, 0, 0, 0, false, false, false, false, 0, vid);
                    e.preventDefault();
                    evt.poster = this.getAttribute("data-poster").replace('_8.', '_6.');
                    vid.setAttribute('data-thumb', this.getAttribute("data-poster"));
                    evt.src = this.getAttribute('data-url');
                    evt.id = this.getAttribute('data-id');
                    evt.fake = true;

                    vid.dispatchEvent(evt);

                    videoPlayer = vid;
                }

                return true;
            });

			if (that.shareHelper) { that.monitorShare(); }
		},

		generateThumbs: function (videoData) {
			if (videoData && videoData.videos) {
				videoData.videos.forEach(function (e, i) {
					if (e.thumb.indexOf('http') !== -1) {
						imageLoader.load(videoData.thumbSelector.call(e), videoData).done(function (src, element) {
							$('#video-' + e.id + ' img').replaceWith(element);
						});
					}
				});
			}
		}
	});

	Superclass = VideosViewController.superclass;
    return VideosViewController;
});
